import { BlockStack, InlineStack, Text, Badge, Button } from '@shopify/polaris';
import BrandAvatar from '@/components/BrandAvatar';
import { IProviderConfig } from '../../config';
import { StyledRow } from './styled';

interface IProviderRowProps {
  provider: IProviderConfig;
  onHowToConnect: () => void;
}

const ProviderRow = ({ provider, onHowToConnect }: IProviderRowProps) => (
  <StyledRow data-testid="provider-row">
    <BrandAvatar brand={provider.brand} />
    <BlockStack gap="100">
      <InlineStack gap="200" blockAlign="center">
        <Text as="span" variant="headingSm">
          {provider.title}
        </Text>
        {provider.subtitle && (
          <Text as="span" tone="subdued" variant="bodySm">
            {provider.subtitle}
          </Text>
        )}
        <Badge>Manual connection</Badge>
      </InlineStack>
      {provider.description && (
        <Text as="p" tone="subdued" variant="bodySm">
          {provider.description}
        </Text>
      )}
    </BlockStack>
    <div className="actions">
      <Button onClick={onHowToConnect}>How to connect</Button>
    </div>
  </StyledRow>
);

export default ProviderRow;
